import css from './index.module.scss';
import OverView from './components/OverView';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { getImageLocal } from '@/utils/locals';
import { TextModule, BannerModule, TextOnImage, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { createEFPic } from '@/utils/useEFPic';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointDeltaBase from '@/components/AppPoint/DeltaBaseH5';
import { SHOW_APP_POINT_SITES } from '@/constants';

const webpUrl = '/media/deltamini/h5/';
const { EFPic } = createEFPic(webpUrl);

export default function DeltaMini({ cssStyle }: any) {
    const { gloproductlist, useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('delta_mini_new');
    const { locale } = useRouter();
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const defaultStyle = {
        background: 'transparent',
        padding: '0',
        margin: '0 auto',
        border: 'none',
        borderRadius: '0',
    };

    const bannerData = [
        {
            bgImgs: ['1_main.webp', '1_main.png'],
            title: t('banner_title_h5'),
            suffix: t('banner_suffix_h5'),
            des: t('banner'),
        },
    ];

    const text3 = {
        text: t('AC_output'),
    };

    const text4 = {
        text: t('AC_output_sub_title'),
    };

    const text5 = {
        text: t.rich('AC_output_desc', {
            line1: (text: string) => (
                <Link className="ef-link__page is-mobile" href="/x-boost" newWin>
                    {text}
                </Link>
            ),
        }),
    };

    const text6 = {
        text: t('AC_output_notice'),
    };

    const text7 = {
        text: t('capacity'),
    };

    const text8 = {
        text: t('capacity_sub_title'),
    };

    const text9 = {
        text: t('capacity_desc'),
    };

    const text10 = {
        text: t('portable_design'),
    };

    const text11 = {
        text: t('portable_design_sub_title'),
    };

    const text12 = {
        text: t('portable_design_desc'),
    };

    const textA1 = {
        text: t('battery_system'),
    };

    const textA2 = {
        text: t('battery_system_sub_title'),
    };

    const textA3 = {
        text: t('battery_system_desc'),
    };

    const text13 = {
        text: t('app_support'),
    };

    const text14 = {
        text: t('app_support_sub_title'),
    };

    const text15 = {
        text: t('app_support_desc'),
    };

    const textStyle2 = {
        fontFamily: 'var(--font-family-SemiBold)',
        fontSize: '0.16rem',
        lineHeight: '0.2rem',
        textAlign: 'left',
        padding: '0 0.45rem',
        backColor: 'transparent',
        color: '#fff',
        margin: '0 auto',
    };

    const textStyle3 = {
        fontFamily: 'var(--font-family-Bold)',
        fontSize: locale === 'de' ? '0.23rem' : '0.24rem',
        lineHeight: '0.34rem',
        textAlign: 'left',
        backColor: 'transparent',
        color: '#fff',
        margin: '0.06rem auto 0',
    };

    const textStyle4 = {
        fontSize: '0.14rem',
        lineHeight: '0.22rem',
        textAlign: 'left',
        backColor: 'transparent',
        color: '#919191',
        margin: '0.08rem auto 0',
        fontFamily: 'var(--font-family-Medium)',
    };

    const textStyle5 = {
        fontSize: '0.12rem',
        opacity: 0.5,
        lineHeight: '0.16rem',
        color: '#919191',
        textAlign: 'left',
        margin: '0.16rem auto 0',
        backColor: 'transparent',
    };

    const unitHForLang = {
        us: 'h',
        jp: '時間',
        de: 'Stunde',
        cn: '时',
    };

    const item1 = {
        title: '',
        synopsis: t('fastest_charging'),
        desc: t('fastest_charging_desc'),
        newWindLink: '/x-stream',
        linkDesc: t('x_stream_link'),
        arr: [
            {
                num: 900,
                eum: 'w',
                desc: t('fastest_charging_desc1'),
                phrase: t('fastest_charging_desc3'),
            },
            {
                num: 1,
                eum: unitHForLang[locale as keyof typeof unitHForLang] || unitHForLang.us,
                desc: t('fastest_charging_desc2'),
            },
        ],
        bgImgs: ['4_main.webp', '4_main.png'],
        icon: ['4_main_icon.webp', '4_main_icon.png'],
    };

    const item2 = {
        img_url: ['6_main.webp', '6_main.webp'],
        title: t('solar_input'),
        synopsis: t('solar_input_sub_title'),
        desc: t('solar_input_desc'),
        phrase: t('solar_input_notice'),
    };
    const styles = { ...defaultStyle, ...cssStyle };
    return (
        <div
            className={`${css.deltamini} DeltaMiniModule`}
            style={{
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                border: styles.border,
                borderRadius: styles.borderRadius,
            }}
        >
            <div className="page-banner">
                <BannerModule data={bannerData} config={{ webpUrl }} />
            </div>
            {/* 新版本一图看懂 */}
            <OverView />
            <LineSpace height={1.2} background="transparent" />
            <TextModule data={text3} cssStyle={textStyle2} />
            <TextModule data={text4} cssStyle={textStyle3} />
            <TextModule data={text5} cssStyle={textStyle4} />
            <TextModule data={text6} cssStyle={textStyle5} />
            <LineSpace height={0.3} background="transparent" />
            <div
                style={{
                    position: 'relative',
                    width: '3.55rem',
                    height: '3.6rem',
                    margin: '0 auto',
                }}
            >
                <EFPic name={['3_main.webp', '3_main.png']} alt={t('1400W AC Output')} />
            </div>
            <LineSpace height={1} background="transparent" />
            <div className="page-text-on-image-a">
                <TextOnImage
                    data={item1}
                    config={{
                        position: 'top',
                        titleColor: '#ededed',
                        synopsisColor: '#fff',
                        descColor: '#919191',
                        synopsisFontSize: '0.24',
                        descFontSize: '0.14',
                        iconWidth: '1.15rem',
                        iconHeight: '0.33rem',
                        itemsColor: '#fff',
                        itemsPhraseColor: '#666666',
                        webpUrl,
                    }}
                />
            </div>
            <LineSpace height={1.17} background="transparent" />
            <TextModule data={text7} cssStyle={textStyle2} />
            <TextModule data={text8} cssStyle={textStyle3} />
            <TextModule data={text9} cssStyle={textStyle4} />
            <LineSpace height={0.3} background="transparent" />
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '3.2rem',
                    margin: '0rem auto',
                }}
            >
                <EFPic name={['5_main.webp', '5_main.png']} className="fullImgs" alt={t('882Wh Capacity')} />
            </div>
            <LineSpace height={0.9} background="transparent" />
            <div className="text-box-b" style={{ display: 'flex', justifyContent: 'center' }}>
                <TextWithImage
                    data={item2}
                    config={{
                        padding: '0.9rem 0',
                        position: 'top',
                        titleColor: '#fff',
                        synopsisColor: '#fff',
                        descColor: '#999',
                        webpUrl,
                    }}
                />
            </div>
            <LineSpace height={0.3} background="transparent" />
            <TextModule data={text10} cssStyle={textStyle2} />
            <TextModule data={text11} cssStyle={textStyle3} />
            <TextModule data={text12} cssStyle={textStyle4} />
            <div
                style={{
                    position: 'relative',
                    width: '3.55rem',
                    height: '3.6rem',
                    margin: '0.3rem auto 0',
                }}
            >
                <EFPic name={['7_main.webp', '7_main.png']} className="fullImgs" alt={t('Portable Design')} />
            </div>
            <LineSpace height={1.8} background="transparent" />
            <TextModule data={textA1} cssStyle={textStyle2} />
            <TextModule data={textA2} cssStyle={textStyle3} />
            <TextModule data={textA3} cssStyle={textStyle4} />
            <div
                style={{
                    position: 'relative',
                    width: '3.75rem',
                    height: '3.2rem',
                    margin: '0.3rem auto 0',
                }}
            >
                <EFPic name={['8_main.webp', '8_main.png']} className="fullImgs" alt={t('Battery Management System')} />
            </div>
            <LineSpace height={1.2} background="transparent" />
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <>
                    <TextModule data={text13} cssStyle={textStyle2} />
                    <TextModule data={text14} cssStyle={textStyle3} />
                    <TextModule data={text15} cssStyle={textStyle4} />
                    <LineSpace height={0.3} background="transparent" />
                    <div style={{ width: '100%', height: '3.2rem', position: 'relative' }}>
                        <EFPic name={[`9_main_${appImgLocal}.webp`, `9_main_${appImgLocal}.jpg`]} className="fullImgs" alt={t('App Support')} />
                    </div>
                </>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && (
                <AppPointDeltaBase />
            )}
            <LineSpace height={1.2} background="transparent" />
            <div className="page-OtherProductModule">
                <OtherList theme="black" data={getDetaileMoreProducts(gloproductlist, ['product_ps_delta_delta_1300', 'product_ps_delta_delta_max'])} />
            </div>
        </div>
    );
}
